export default __webpack_public_path__ + "static/media/yahoo.329af5f8.svg";